module.exports = __webpack_public_path__ + "static/media/back.14bd038a.png";